// #region imports

// --- 3rd Party
import { Profile } from 'oidc-client';
import { isNull, isUndefined } from 'lodash';

// --- HS Code
import { Constants } from '../../../models';

// #endregion

export class Claims {
  private _claims: { [key: string]: string } = {};

  loadClaims(profile: Profile): void {
    let claimNames: Array<string> = [];

    for (const [key, value] of Object.entries(Constants)) {
      if (key.startsWith('CLAIMS_')) {
        claimNames.push(value);
      }
    }

    this._claims = {};

    claimNames.forEach(claimName => {
      this._claims[claimName] = profile[claimName];
    });
  }

  getClaimValue(claimName: string): string {
    return this._claims[claimName];
  }

  hasClaim(claimName: string): boolean {
    const result = this._claims[claimName];
    if (!isNull(result) && !isUndefined(result)) return true;

    return false;
  }

  is(claimName: string) {
    const result = this._claims[claimName];
    if (isNull(result) || isUndefined(result)) return false;

    return result === 'True' || result === 'true' || result === 'TRUE';
  }
}
